"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
require("./TaskCallout.css");
var _CompletedContext = require("../CompletedContext");
var _ShrinkToFit = _interopRequireDefault(require("../ShrinkToFit/ShrinkToFit"));
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
var _Figure = _interopRequireDefault(require("../Figure/Figure"));
var CalloutHotspot = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CalloutHotspot, _Component);
  var _super = (0, _createSuper2.default)(CalloutHotspot);
  function CalloutHotspot(props) {
    var _this;
    (0, _classCallCheck2.default)(this, CalloutHotspot);
    _this = _super.call(this, props);
    _this.state = {
      selected: false,
      buttonState: null
    };
    _this.onMouseIn = _this.onMouseIn.bind((0, _assertThisInitialized2.default)(_this));
    _this.onMouseOut = _this.onMouseOut.bind((0, _assertThisInitialized2.default)(_this));
    _this.setButtonState = _this.setButtonState.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(CalloutHotspot, [{
    key: "setButtonState",
    value: function setButtonState(newButton) {
      this.setState({
        buttonState: newButton
      });
    }
  }, {
    key: "onMouseIn",
    value: function onMouseIn() {
      if (!this.state.selected) {
        this.setState({
          selected: true
        });
      }
      this.props.onMouseInteract();
    }
  }, {
    key: "onMouseOut",
    value: function onMouseOut() {
      if (this.state.selected) {
        this.setState({
          selected: false
        });
      }
      this.props.onMouseInteract();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$placement;
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "callout",
        ref: this.setButtonState,
        id: "task-callouts-tab-" + this.props.index,
        tabIndex: "0",
        style: this.props.style,
        key: this.props.index,
        "aria-describedby": "task-callouts-tooltip-" + this.props.index,
        "aria-label": this.props.label,
        onMouseEnter: this.onMouseIn,
        onMouseOver: this.onMouseIn,
        onPointerDown: this.onMouseIn,
        onGotPointerCapture: this.onMouseIn,
        onPointerOver: this.onMouseIn,
        onPointerEnter: this.onMouseIn,
        onTouchStart: this.onMouseIn,
        onFocus: this.onMouseIn,
        onMouseLeave: this.onMouseOut,
        onMouseOut: this.onMouseOut,
        onPointerOut: this.onMouseOut,
        onTouchEnd: this.onMouseOut,
        onBlur: this.onMouseOut
      }, this.state.selected && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        tooltipId: "task-callouts-tooltip-" + this.props.index,
        placement: (_this$props$placement = this.props.placement) !== null && _this$props$placement !== void 0 ? _this$props$placement : "right",
        content: this.props.content,
        target: this.state.buttonState
      }));
    }
  }]);
  return CalloutHotspot;
}(_react.Component);
var TaskCallout = exports.default = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(TaskCallout, _Component2);
  var _super2 = (0, _createSuper2.default)(TaskCallout);
  function TaskCallout(props) {
    var _this2;
    (0, _classCallCheck2.default)(this, TaskCallout);
    _this2 = _super2.call(this, props);
    _this2.state = props.state || {};
    if (!_this2.state.initialized) {
      _this2.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this2.state.completed = false;
      _this2.state.completed_hotspots = [];
      _this2.state.completed_hotspots.length = props.hotspots.length;
    }
    _this2.onMouseInteract = _this2.onMouseInteract.bind((0, _assertThisInitialized2.default)(_this2));
    return _this2;
  }
  (0, _createClass2.default)(TaskCallout, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this3.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "onMouseInteract",
    value: function onMouseInteract(k) {
      this.setState(function (state, props) {
        var hotspots = state.completed_hotspots.slice();
        hotspots[k] = true;
        var completed = true;
        for (var i = 0; i < props.hotspots.length; ++i) {
          if (!hotspots[i]) {
            completed = false;
          }
        }
        return {
          completed_hotspots: hotspots,
          completed: completed,
          lastSelected: k
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      if (!this.props.alt && !this.props.suppressErrors) {
        throw new Error("TaskCallout: Prop 'alt' not specified");
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "task task-callout " + (this.props.className || ""),
        style: this.props.style
      }, /*#__PURE__*/_react.default.createElement(_ShrinkToFit.default, null, this.props.picture || this.props.src ? /*#__PURE__*/_react.default.createElement(_Figure.default, {
        src: this.props.picture || this.props.src,
        alt: this.props.alt,
        photoCredit: this.props.photoCredit,
        caption: this.props.caption,
        topCaption: this.props.topCaption,
        suppressErrors: this.props.suppressErrors,
        width: this.props.width || "560px",
        longAlt: this.props.longAlt,
        alignment: this.props.alignment
      }) : this.props.children, this.props.hotspots.map(function (v, k) {
        if (!v.label && !_this4.props.suppressErrors) {
          throw new Error("TaskCallout: hotspot ".concat(k, " has no label."));
        }
        var bR = "0%";
        if (v.shape === "Circle") {
          bR = "50%";
        }
        return /*#__PURE__*/_react.default.createElement(CalloutHotspot, {
          key: k,
          onMouseInteract: function onMouseInteract() {
            return _this4.onMouseInteract(k);
          },
          style: (0, _objectSpread2.default)({
            borderRadius: bR
          }, v.style),
          content: v.content,
          placement: v.placement,
          index: k,
          totalItems: _this4.props.hotspots.length,
          label: v.label,
          lastSelected: k === _this4.state.lastSelected
        });
      })));
    }
  }]);
  return TaskCallout;
}(_react.Component);
TaskCallout.contextType = _CompletedContext.CompletedContext;